import React, { useState } from "react";
import API from "../../ApiService/ApiService";
import Context from "./index";
const PearlsV2Provider = (props) => {
  const api = new API();
  const [PEARLSV2SpecilityFilter, setPEARLSV2SpecilityFilter] = useState({
    name: "",
    page: 1,
    limit: 20,
  });
  const [PEARLSV2SpecilityList, setPEARLSV2SpecilityList] = useState([]);
  const [PEARLSV2SpecilityLoader, setPEARLSV2SpecilityLoader] = useState(false);
  const [PEARLSV2TopicFilter, setPEARLSV2TopicFilter] = useState({
    name: "",
    page: 1,
    limit: 20,
  });
  const [PEARLSV2TopicList, setPEARLSV2TopicList] = useState([]);
  const [PEARLSV2TopicLoader, setPEARLSV2TopicLoader] = useState(false);
  const [PEARLSV2SubTopicFilter, setPEARLSV2SubTopicFilter] = useState({
    name: "",
    page: 1,
    limit: 20,
  });
  const [PEARLSV2SubTopicList, setPEARLSV2SubTopicList] = useState([]);
  const [PEARLSV2SubTopicLoader, setPEARLSV2SubTopicLoader] = useState(false);
  const [PEARLSV2PEARLSFilter, setPEARLSV2PEARLSFilter] = useState({
    name: "",
    page: 1,
    limit: 20,
  });
  const [PEARLSV2PEARLSList, setPEARLSV2PEARLSList] = useState([]);
  const [PEARLSV2PEARLSLoader, setPEARLSV2PEARLSLoader] = useState(false);

  const fetchPEARLSV2Specility = async () => {
    setPEARLSV2SpecilityLoader(true);
    localStorage.getItem("rxdx_admin_login") &&
      await api.getAll("pearls/pearls_speciality_list_v2", { ...PEARLSV2SpecilityFilter }, (err, res) => {
        if (res?.data?.status === 200) {
          setPEARLSV2SpecilityList(res?.data?.data);
          setPEARLSV2SpecilityLoader(false);
        } else {
          setPEARLSV2SpecilityList([]);
          setPEARLSV2SpecilityLoader(false);
        }
      });
  }

  const fetchPEARLSV2Topic = async (subcategory_id=null) => {
    if(!subcategory_id) return;
    setPEARLSV2TopicLoader(true);
    localStorage.getItem("rxdx_admin_login") &&
      await api.getAll("pearls/pearls_topic_list_v2", { ...PEARLSV2TopicFilter, subcategory_id }, (err, res) => {
        if (res?.data?.status === 200) {
          setPEARLSV2TopicList(res?.data?.data);
          setPEARLSV2TopicLoader(false);
        } else {
          setPEARLSV2TopicList([]);
          setPEARLSV2TopicLoader(false);
        }
      });
  }

  const fetchPEARLSV2SubTopic = async (subject_id=null) => {
    if(!subject_id) return;
    setPEARLSV2SubTopicLoader(true);
    localStorage.getItem("rxdx_admin_login") &&
      await api.getAll("pearls/pearls_subtopic_list_v2", { ...PEARLSV2SubTopicFilter, subject_id }, (err, res) => {
        if (res?.data?.status === 200) {
          setPEARLSV2SubTopicList(res?.data?.data);
          setPEARLSV2SubTopicLoader(false);
        } else {
          setPEARLSV2SubTopicList([]);
          setPEARLSV2SubTopicLoader(false);
        }
      });
  }

  const fetchPEARLSV2PEARLS = async (topic_id=null) => {
    if(!topic_id) return;
    setPEARLSV2PEARLSLoader(true);
    localStorage.getItem("rxdx_admin_login") &&
      await api.getAll("pearls/pearls_notes_list_v2", { ...PEARLSV2PEARLSFilter, topic_id }, (err, res) => {
        if (res?.data?.status === 200) {
          setPEARLSV2PEARLSList(res?.data?.data);
          setPEARLSV2PEARLSLoader(false);
        } else {
          setPEARLSV2PEARLSList([]);
          setPEARLSV2PEARLSLoader(false);
        }
      });
  }

  return (
    <Context.Provider
      value={{
        ...props,
        PEARLSV2SpecilityFilter, setPEARLSV2SpecilityFilter,
        PEARLSV2SpecilityList, setPEARLSV2SpecilityList,
        PEARLSV2SpecilityLoader, setPEARLSV2SpecilityLoader,
        fetchPEARLSV2Specility,
        PEARLSV2TopicFilter, setPEARLSV2TopicFilter,
        PEARLSV2TopicList, setPEARLSV2TopicList,
        PEARLSV2TopicLoader, setPEARLSV2TopicLoader,
        fetchPEARLSV2Topic,
        PEARLSV2SubTopicFilter, setPEARLSV2SubTopicFilter,
        PEARLSV2SubTopicList, setPEARLSV2SubTopicList,
        PEARLSV2SubTopicLoader, setPEARLSV2SubTopicLoader,
        fetchPEARLSV2SubTopic,
        PEARLSV2PEARLSFilter, setPEARLSV2PEARLSFilter,
        PEARLSV2PEARLSList, setPEARLSV2PEARLSList,
        PEARLSV2PEARLSLoader, setPEARLSV2PEARLSLoader,
        fetchPEARLSV2PEARLS,
      }}
    >
      {props.children}
    </Context.Provider>
  );
};

export default PearlsV2Provider;
